// extracted by mini-css-extract-plugin
export default {"background":"Layout_background__OILFr","wrap":"Layout_wrap__24SeB","navbar":"Layout_navbar__jzhti"};